"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amend = exports.asAny = exports.as = void 0;
function as(subject) {
    return subject;
}
exports.as = as;
function asAny(subject) {
    return subject;
}
exports.asAny = asAny;
/**
 * amend `subject` with type `T`
 */
function amend(subject) {
    return {
        union() {
            return subject;
        },
        intersect() {
            return subject;
        }
    };
}
exports.amend = amend;
//# sourceMappingURL=as.js.map